import { render, staticRenderFns } from "./ProductControlBoxSelect.vue?vue&type=template&id=5e49f390&scoped=true"
import script from "./ProductControlBoxSelect.vue?vue&type=script&lang=js"
export * from "./ProductControlBoxSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e49f390",
  null
  
)

export default component.exports